import { useIntl } from "react-intl";
import { useMemo } from "react";

import ContactForm from "../../components/ContactForm";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";
import SectionBox from "../../components/SectionBox";
import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationModal from "../../components/DeclarationModal";

import FAQ from "../../components/FAQ";

import Variables from "../../variables/variables.json";
import BackButton from "../../components/BackButton";

import JakOtrzymacNumerPeselSection1PL from "../../content/przyjaznedeklaracje/jak-otrzymac-numer-pesel/section-1_pl.mdx";
import BackgroundSection from "../../components/BackgroundSection";
import TranslatedMessage from "../../components/TranslatedMessage";
import Image from "next/image";

export default function Pesel(props) {
	const intl = useIntl();

	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "pesel";
	let przyjazneTranslate = `miasta.${Miasto}`;

	// Memoizowanie tłumaczeń dla akcji
	const downloadUrl = useMemo(() => {
		return intl.formatMessage({
			id: `${przyjazneTranslate}.sections.pobierzdrukpapierowy.action.url`,
		});
	}, [intl, przyjazneTranslate]);

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<Section title="sections.jakuzyskacpesel.title">
				<SectionBox light round section="jakuzyskacpesel" />
			</Section>

			<Section mdx lightdark>
				<JakOtrzymacNumerPeselSection1PL />
			</Section>

			<Section title="sections.najczesciejzadawanepytaniafaq.title">
				<FAQ miasto={Miasto} section="pesel" secondary number />
			</Section>

			<BackgroundSection
				miasto={Miasto}
				section="wniosekopesel"
				fillRightTop
				textAlign="left"
				center
				transparent
				bgColor="lightblue"
				customContent
			>
				<div className="paper-print">
					<h2 className="paper-print__title">
						<TranslatedMessage id={`${przyjazneTranslate}.sections.pobierzdrukpapierowy.title`} />
					</h2>
					<div className="paper-print__container">
						<div className="paper-print__column__one">
							<Image
								unoptimized
								src="https://przyjazne-deklaracje.pl/resources/images/icons/general/files/download_from_cloud.png"
								alt=""
								width={367}
								height={388}
								className="paper-print__image"
								style={{
									maxWidth: "100%",
									height: "auto",
								}}
							/>
						</div>
						<div className="paper-print__column__two">
							<div className="paper-print__description">
								<TranslatedMessage
									id={`${przyjazneTranslate}.sections.pobierzdrukpapierowy.description`}
								/>
							</div>
							<div className="paper-print__action">
								<a className="pd-btn pd-btn--outline" href={downloadUrl}>
									<TranslatedMessage
										id={`${przyjazneTranslate}.sections.pobierzdrukpapierowy.action.title`}
									/>
								</a>
							</div>
						</div>
					</div>
				</div>
			</BackgroundSection>
		</SectionLayout>
	);
}
